import { Component } from '@angular/core';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: []
})
export class AboutUsComponent { constructor()
  {
    window.scrollTo(0, 0);
  }
}
